import { render, staticRenderFns } from "./LoyaltyLevelFoldablePanel.vue?vue&type=template&id=5bfa8a89&scoped=true&"
import script from "./LoyaltyLevelFoldablePanel.vue?vue&type=script&lang=js&"
export * from "./LoyaltyLevelFoldablePanel.vue?vue&type=script&lang=js&"
import style0 from "./LoyaltyLevelFoldablePanel.vue?vue&type=style&index=0&id=5bfa8a89&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bfa8a89",
  null
  
)

export default component.exports